import { Phone, Mail, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import logoImg from "@/assets/logo.png";

const quickLinks = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Services", href: "/services" },
  { label: "Pricing", href: "/pricing" },
  { label: "Gallery", href: "/gallery" },
  { label: "Contact", href: "/contact" },
];

const Footer = () => (
  <footer className="relative bg-charcoal-gradient overflow-hidden noise-overlay">
    <div className="absolute top-0 left-0 right-0 premium-divider" />
    <div className="absolute top-0 right-0 w-64 h-64 bg-primary/3 rounded-full blur-[120px]" />
    
    <div className="section-padding relative z-10">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 mb-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <img src={logoImg} alt="Precision Mobile Auto" className="h-10 w-10 object-contain" />
              <div>
                <span className="font-heading text-sm sm:text-base uppercase tracking-wider text-secondary-foreground block leading-tight">
                  Precision
                </span>
                <span className="font-heading text-[10px] sm:text-xs uppercase tracking-[0.2em] text-primary block leading-tight">
                  Mobile Auto
                </span>
              </div>
            </div>
            <p className="text-silver/60 text-xs sm:text-sm leading-relaxed">
              Professional mobile auto repair by Patrick Kungu &amp; Meja Jenerali. Engineering precision at your doorstep.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-xs sm:text-sm uppercase tracking-widest text-primary mb-5">Quick Links</h4>
            <div className="space-y-2.5">
              {quickLinks.map((link) => (
                <Link key={link.href} to={link.href} className="block text-silver/60 text-xs sm:text-sm hover:text-primary transition-colors duration-300">
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-xs sm:text-sm uppercase tracking-widest text-primary mb-5">Contact Us</h4>
            <div className="space-y-3">
              <a href="tel:+254700000000" className="flex items-center gap-2.5 text-silver/60 text-xs sm:text-sm hover:text-primary transition-colors duration-300">
                <Phone className="h-3.5 w-3.5 shrink-0 text-primary/50" /> +254 700 000 000
              </a>
              <a href="mailto:info@precisionmobileauto.co.ke" className="flex items-center gap-2.5 text-silver/60 text-xs sm:text-sm hover:text-primary transition-colors duration-300">
                <Mail className="h-3.5 w-3.5 shrink-0 text-primary/50" /> info@precisionmobileauto.co.ke
              </a>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h4 className="font-heading text-xs sm:text-sm uppercase tracking-widest text-primary mb-5">Hours</h4>
            <div className="space-y-2.5 text-silver/60 text-xs sm:text-sm">
              <div className="flex items-center gap-2.5">
                <Clock className="h-3.5 w-3.5 shrink-0 text-primary/50" />
                <span>Mon – Sat: 7 AM – 7 PM</span>
              </div>
              <div className="flex items-center gap-2.5">
                <Clock className="h-3.5 w-3.5 shrink-0 text-primary/50" />
                <span>Sun: Emergency only</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-silver/10 pt-6 text-center">
          <p className="text-silver/40 text-[10px] sm:text-xs tracking-wider">
            &copy; {new Date().getFullYear()} Precision Mobile Auto. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
